"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftPurchaseCartItemToJSON = exports.NftPurchaseCartItemFromJSONTyped = exports.NftPurchaseCartItemFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function NftPurchaseCartItemFromJSON(json) {
    return NftPurchaseCartItemFromJSONTyped(json, false);
}
exports.NftPurchaseCartItemFromJSON = NftPurchaseCartItemFromJSON;
function NftPurchaseCartItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'nftSaleConfig': json['nftSaleConfig'],
        'quantity': json['quantity'],
        'price': json['price'],
        'subtotal': json['subtotal'],
        'transactions': !(0, runtime_1.exists)(json, 'transactions') ? undefined : (json['transactions'].map(_1.NftPurchaseTransactionFromJSON)),
    };
}
exports.NftPurchaseCartItemFromJSONTyped = NftPurchaseCartItemFromJSONTyped;
function NftPurchaseCartItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'nftSaleConfig': value.nftSaleConfig,
        'quantity': value.quantity,
        'price': value.price,
        'subtotal': value.subtotal,
        'transactions': value.transactions === undefined ? undefined : (value.transactions.map(_1.NftPurchaseTransactionToJSON)),
    };
}
exports.NftPurchaseCartItemToJSON = NftPurchaseCartItemToJSON;
